import React, { useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button, Row, Space, Toggle } from "@masterteam/mt-design-react";

import { useIsAr } from "../../../Hooks";
import api from "../../../providers/api";
import { addToast } from "../../../helpers";

import { ReactComponent as FilterIcon } from "../../../assets/images/filter.svg";

import "./style.scss";

const Header = ({ data, getStrategyData }) => {
  const intl = useIntl();
  const [isAr] = useIsAr();
  const [loading, setLoading] = useState(false);
  const [isOpened, setIsOpened] = useState(false);
  const [values, setValues] = useState(data?.ShowValues);
  const [summary, setSummary] = useState(data?.ShowSummary);
  const [visionMission, setVisionMission] = useState(data?.ShowVisionMission);

  const showHideSections = async () => {
    setLoading(true);
    try {
      const res = await api.strategyMap.showHideSections({
        StrategyID: data?.ID,
        ShowSummary: summary,
        ShowVisionMission: visionMission,
        ShowValues: values,
      });

      if (res.Data) {
        getStrategyData();
        setIsOpened(false);
      }
    } catch (err) {
      addToast.error(err.message, {
        toastId: "get-users-error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Row
      size="large"
      align="center"
      justify="between"
      className="header-container"
    >
      <div className="header-container__title">
        {isAr ? data?.ArabicName : data?.EnglishName}
      </div>

      <div
        className="header-container__dropdown-wrapper"
        style={{ direction: isAr ? "ltr" : "rtl" }}
      >
        <div
          className="header-container__filter-icon"
          onClick={() => {
            setIsOpened(!isOpened);
            setValues(data?.ShowValues);
            setSummary(data?.ShowSummary);
            setVisionMission(data?.ShowVisionMission);
          }}
        >
          <FilterIcon />
        </div>

        {isOpened && (
          <div
            className="header-container__dropdown"
            style={{ direction: isAr ? "rtl" : "ltr" }}
          >
            <Space direction="vertical" size="medium">
              <Row justify="between">
                <FormattedMessage id="strategy.show-summary" />
                <Toggle
                  checked={summary}
                  name="summary"
                  id="summary"
                  variant="primary"
                  onChange={(_, checked) => {
                    setSummary(!checked);
                  }}
                  hideErrorMessage
                />
              </Row>

              <Row justify="between">
                <FormattedMessage id="strategy.show-vision-mission" />
                <div>
                  <Toggle
                    checked={visionMission}
                    name="visionMission"
                    id="visionMission"
                    variant="primary"
                    onChange={(_, checked) => {
                      setVisionMission(!checked);
                    }}
                    hideErrorMessage
                  />
                </div>
              </Row>

              <Row justify="between">
                <FormattedMessage id="strategy.show-values" />
                <Toggle
                  checked={values}
                  name="values"
                  id="values"
                  variant="primary"
                  onChange={(_, checked) => {
                    setValues(!checked);
                  }}
                  hideErrorMessage
                />
              </Row>
            </Space>

            <Row justify="end" className="buttons-wrapper" gap={8}>
              <Button
                variant="primary"
                loading={loading}
                onClick={showHideSections}
              >
                {intl.formatMessage({
                  id: "common.apply",
                })}
              </Button>

              <Button
                variant="dark"
                disabled={loading}
                onClick={() => {
                  setIsOpened(false);
                  setValues(data?.ShowValues);
                  setSummary(data?.ShowSummary);
                  setVisionMission(data?.ShowVisionMission);
                }}
              >
                {intl.formatMessage({
                  id: "common.cancel",
                })}
              </Button>
            </Row>
          </div>
        )}
      </div>
    </Row>
  );
};

export default Header;
